"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Has implicit dependency to `bronson.Notification' for closing behaviour.
 */
var NBWNotification = /** @class */ (function () {
    function NBWNotification(notification) {
        var _this = this;
        this._notification = notification;
        this._pageId = this._notification.dataset.pageId || 'notification';
        this._closeStorageKey = "".concat(this._pageId, "_close");
        this._closeButton = this._notification.querySelector('#js-dmp-notification-close');
        if (this._closeButton) {
            this._closeButton.id = this._closeStorageKey;
            this._closeButton.onclick = function () {
                sessionStorage.setItem(_this._closeStorageKey, 'notificationClosed');
            };
        }
        // If there is no close button, the notification must still be shown.
        if (!this._closeButton || (!sessionStorage.getItem(this._closeStorageKey))) {
            this._notification.classList.remove('u-hide');
        }
    }
    return NBWNotification;
}());
exports.default = NBWNotification;
/**
 * ON DOCUMENT LOADED
 */
document.addEventListener('DOMContentLoaded', function () {
    console.debug('INFO notification.js loaded');
    var notificationEls = document.querySelectorAll('.js-dmp-notification');
    notificationEls.forEach(function (notificationEl) {
        try {
            new NBWNotification(notificationEl);
        }
        catch (e) {
            console.error('An error while creating a new NBW_Notification instance: {}', e);
        }
    });
});
